// Copyright (c) Hamilton Manufacturing Corp.
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { generateId } from '../api/utility';
import { FormContext } from './Form';

const Wrapper = styled.div`
    display: grid;
    grid-template-areas: "select";
    align-items: center;
    position: relative;
    cursor: pointer;
    select,
        &::after {
        grid-area: select;
    }
    &::after {
        content: "";
        width: 0.8em;
        height: 0.5em;
        clip-path: polygon(100% 0%, 0 0%, 50% 100%);
        justify-self: end;
        transition: all 0.2s;
        background-color: ${({ theme }) => theme.input.text};
        transform: ${({ active }) => active ? 'rotate(180deg)' : `rotate(0deg)`};
    }

    border-radius: 0.15em;
    padding: 0.25em 0.5em;
    color: ${({ theme }) => theme.input.text};
    background-color: ${({ theme }) => theme.input.background};
    border: 1px solid ${({ value, theme }) => value ? theme.input.disabled : `${theme.input.disabled}40`};
    margin: 0.4em;

    margin: 0.4em 0.5em 0.4em 0.4em;

    
    ${({ disabled, theme }) =>
        disabled && `
        color: ${theme.input.disabledText};
        background-color: ${theme.input.disabled};
        cursor: default;
    `}
`;

const SelectCSS = styled.select`
    color: ${({ theme }) => theme.input.text};
    appearance: none;
    background-color: transparent;
    border: none;
    width: 100%;
    font-family: inherit;
    font-size: inherit;
    cursor: inherit;
    line-height: inherit;
    z-index: 1;
    outline: none;
    padding: 3px 1em 3px 6px;
    margin: 0;
    &::-ms-expand {
        display: none;
    }
`;
const Option = styled.option`
    color: ${({ theme }) => theme.input.text};
    background-color: ${({ theme }) => theme.input.background};
    padding: 2em;
`
const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const MinContent = styled.div`
    margin: 0 0.5em;
`;
const Select = ({ options = [], ...props }) => {
    const [isActive, setIsActive] = useState(false)

    if (props.nullable && !options.find(e => e.id === 'nullable')) {
        options.unshift({ value: '', label: '-', id: 'nullable' })
    }

    return (
        <Row {...props}>
            <MinContent>
                {props.label}
            </MinContent>
            <Wrapper active={isActive}>
                {props.standalone ?
                    <SelectCSS
                        onClick={() => setIsActive(!isActive)}
                        onBlur={() => setIsActive(false)}
                        {...props}
                    >
                        {props.children}
                        {options.map(e => <Option key={generateId()} value={e.value} {...e}>{e.label}</Option>)}
                    </SelectCSS> :
                    <FormSelect
                        onClick={() => setIsActive(!isActive)}
                        onBlur={() => setIsActive(false)}
                        {...props}
                    >
                        {props.children}
                        {options.map(e => <Option key={generateId()} value={e.value} {...e}>{e.label}</Option>)}
                    </FormSelect>}
            </Wrapper>
        </Row>
    );
}


const FormSelect = ({ ...props }) => {
    const { values, submitting, editing, setValues, errors, setErrors } = useContext(FormContext);

    const [disable, setDisable] = useState(false);

    const [firstRun, setFirstRun] = useState(true);

    // useEffect(() => {
    //     if (!props.disabledcondition) return;
    //     setDisable(values[props.disabledcondition]);
    //     if (values[props.disabledcondition]) {
    //         setInvalidation(false)
    //     } else {
    //         // setInvalidation(true)
    //     }
    // }, [values])

    useEffect(() => {
        if (firstRun) {
            setFirstRun(false)
            return;
        }

        setDisable(values[props.disabledcondition]);

        if (!props.disabledcondition) return;
        if (values[props.disabledcondition]) {
            setErrors(v => {
                return {
                    ...v,
                    [props.name]: false
                }
            });
        } else {
            handleChange(values[props.name])
        }
    }, [values[props.disabledcondition]])

    useEffect(() => {
        if (!props.required && errors[props.name] === 'unTouched') {
            if (errors[props.name] === false) return;
            setErrors({
                ...errors,
                [props.name]: false
            })
        }
    }, [errors, setErrors]);

    const handleChange = (e) => {
        setErrors({
            ...errors,
            [props.name]: props.required && !e ? true : false
        })

        setValues({
            ...values,
            [props.name]: e
        })
    }

    return (
        <SelectCSS
            onChange={(e) => handleChange(e.target.value)}
            value={values[props.name] || ''}
            disabled={props.disabled || submitting || !editing || disable}
            {...props}
        />
    );
}

export default Select;